import { InvalidGroupEditMessages } from "@/utils/groupInfo"

export default {
	...InvalidGroupEditMessages
}
